import React from "react";

const Share = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="m21.598 26.877-8.58-4.694a5.861 5.861 0 0 1-6.4 1.258 5.88 5.88 0 0 1-2.63-2.17 5.907 5.907 0 0 1 0-6.541 5.88 5.88 0 0 1 2.63-2.171 5.861 5.861 0 0 1 6.4 1.258l8.58-4.694a5.91 5.91 0 0 1 .598-4.07 5.882 5.882 0 0 1 3.107-2.686 5.86 5.86 0 0 1 4.102.007 5.882 5.882 0 0 1 3.099 2.696 5.91 5.91 0 0 1-1.628 7.536 5.864 5.864 0 0 1-7.67-.527l-8.58 4.693c.17.81.17 1.646 0 2.456l8.58 4.693a5.864 5.864 0 0 1 7.67-.528 5.91 5.91 0 0 1 1.628 7.536 5.882 5.882 0 0 1-3.099 2.697 5.86 5.86 0 0 1-4.102.007 5.882 5.882 0 0 1-3.107-2.686 5.91 5.91 0 0 1-.599-4.07Z"
              fill={fill}
        />
    </svg>
);

export default Share;